import { $gettext } from '@/services/translations'

const ONE_TIME = 'ONE_TIME'
const RECURRING = 'RECURRING'

const FREQUENCY_CHOICES = [
  {
    value: RECURRING,
    labelEn: $gettext('Monthly', 'en_US'),
    labelEs: $gettext('Monthly', 'es_ES'),
  },
  {
    value: ONE_TIME,
    labelEn: $gettext('One time', 'en_US'),
    labelEs: $gettext('One time', 'es_ES'),
  },
]

export default {
  ONE_TIME,
  RECURRING,
  FREQUENCY_CHOICES,
}
